import { ConversationAuditLogEntry } from 'apis/auditLogs';

import { LogEntry } from './logEntry';

type AutoreplySentProps = {
  entry: ConversationAuditLogEntry<'CONVERSATION_AUTOREPLY_SENT'>;
};

export const AutoreplySent = ({ entry }: AutoreplySentProps): JSX.Element => {
  const text = `Conversation autoreply sent with template ${entry.template_name}`;

  return <LogEntry entry={entry} text={text} />;
};
